"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./data/types");
var mathjs_1 = require("mathjs");
var ratios_1 = __importDefault(require("./ratios"));
var Resources = /** @class */ (function () {
    function Resources(_a) {
        var _b = _a === void 0 ? {
            initialResources: 0,
            resources: {}
        } : _a, _c = _b.initialResources, initialResources = _c === void 0 ? 0 : _c, _d = _b.resources, resources = _d === void 0 ? {} : _d;
        this[types_1.ResourceTypes.Wood] = resources[types_1.ResourceTypes.Wood] ? resources[types_1.ResourceTypes.Wood] : initialResources;
        this[types_1.ResourceTypes.Metal] = resources[types_1.ResourceTypes.Metal] ? resources[types_1.ResourceTypes.Metal] : initialResources;
        this[types_1.ResourceTypes.Cloth] = resources[types_1.ResourceTypes.Cloth] ? resources[types_1.ResourceTypes.Cloth] : initialResources;
        this[types_1.ResourceTypes.Diamond] = resources[types_1.ResourceTypes.Diamond] ? resources[types_1.ResourceTypes.Diamond] : initialResources;
    }
    Resources.hydrate = function (obj) {
        var resources = Object.assign(new Resources(), obj);
        return resources;
    };
    Resources.prototype.map = function (cb) {
        var rv = [];
        var symbols = Object.getOwnPropertySymbols(this);
        symbols.forEach(function (sym, i) {
            // @ts-ignore
            var name = Symbol.keyFor(sym).toString();
            var nameCapitalized = name.charAt(0).toUpperCase() + name.slice(1);
            rv.push(cb(sym, nameCapitalized, i));
        });
        return rv;
    };
    Resources.prototype.add = function (resources) {
        this[types_1.ResourceTypes.Wood] += resources[types_1.ResourceTypes.Wood];
        this[types_1.ResourceTypes.Metal] += resources[types_1.ResourceTypes.Metal];
        this[types_1.ResourceTypes.Cloth] += resources[types_1.ResourceTypes.Cloth];
        this[types_1.ResourceTypes.Diamond] += resources[types_1.ResourceTypes.Diamond];
        return this;
    };
    Resources.prototype.sub = function (resources) {
        this[types_1.ResourceTypes.Wood] -= resources[types_1.ResourceTypes.Wood];
        this[types_1.ResourceTypes.Metal] -= resources[types_1.ResourceTypes.Metal];
        this[types_1.ResourceTypes.Cloth] -= resources[types_1.ResourceTypes.Cloth];
        this[types_1.ResourceTypes.Diamond] -= resources[types_1.ResourceTypes.Diamond];
        return this;
    };
    Resources.prototype.sum = function () {
        return (this[types_1.ResourceTypes.Wood] +
            this[types_1.ResourceTypes.Metal] +
            this[types_1.ResourceTypes.Cloth] +
            this[types_1.ResourceTypes.Diamond]);
    };
    Resources.prototype.gcd = function () {
        return mathjs_1.gcd(this[types_1.ResourceTypes.Wood], this[types_1.ResourceTypes.Metal], this[types_1.ResourceTypes.Cloth], this[types_1.ResourceTypes.Diamond]);
    };
    Resources.prototype.ratios = function () {
        var gcd = this.gcd();
        var ratios = new ratios_1.default();
        ratios[types_1.ResourceTypes.Wood] = this[types_1.ResourceTypes.Wood] / gcd;
        ratios[types_1.ResourceTypes.Metal] = this[types_1.ResourceTypes.Metal] / gcd;
        ratios[types_1.ResourceTypes.Cloth] = this[types_1.ResourceTypes.Cloth] / gcd;
        ratios[types_1.ResourceTypes.Diamond] = this[types_1.ResourceTypes.Diamond] / gcd;
        return ratios;
    };
    return Resources;
}());
exports.default = Resources;
